import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ForbiddenComponent} from './Forbidden/Forbidden.component';
import {AdminLayoutComponent} from './management/layouts/admin-layout/admin-layout.component';


const routes: Routes = [
  {path: '', loadChildren: './login/login.module#LoginModule' },
  {path: 'manager', loadChildren: './management/management.module#ManagementModule'},
  {path:'forbidden',component: ForbiddenComponent},
];
// const routes: Routes = [
//   {
//     path: 'manager',
//     component: AdminLayoutComponent,
//     children: [
//       {
//         path: '',
//         loadChildren:
//           './layouts/admin-layout/admin-layout.module#AdminLayoutModule'
//       }
//     ]
//   },
//   {
//     path: '',
//     loadChildren:
//       './login/login.module#LoginModule'
//   },
//   {
//     path:'forbidden',
//     component: ForbiddenComponent
//   },
// ];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:false})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
